/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */

import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import { SpotMarker as QuiverSpotMarker } from '@surfline/quiver-react';

const getClassName = (current) =>
  classNames({
    'sl-spot-marker': true,
    'sl-spot-marker--current': current,
  });

const SpotMarker = (props) => (
  <div
    className={getClassName(props.current)}
    onClick={props.onClick}
    onMouseEnter={props.onMouseEnter}
    onMouseLeave={props.onMouseLeave}
  >
    <QuiverSpotMarker {...props} />
  </div>
);

SpotMarker.propTypes = {
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  onClick: PropTypes.func,
  current: PropTypes.bool,
};

SpotMarker.defaultProps = {
  onMouseEnter: () => null,
  onMouseLeave: () => null,
  onClick: () => null,
  current: false,
};

export default SpotMarker;
